import PaymentOptions from './PaymentOptionData.json'

// Card fees (Korapay) are too high on large NGN payments, so above ₦20,000 only bank transfer is offered.
export const CARD_MAX_NGN_KOBO = 2000000;

// amount in kobo and currency of the payment this checkout is for
export function checkoutAmount(auth, dashData) {
  if (auth?.source === "dashboard") {
    const kobo = (auth?.isFixedAmount && auth?.amount !== "0") ? auth?.amount : dashData?.amount;
    return { kobo: Number(kobo), currency: dashData?.currency || auth?.currency };
  }
  return { kobo: Number(auth?.cbInfo?.amount), currency: auth?.cbInfo?.currency_collected || auth?.cbInfo?.currency || auth?.currency };
}

export function availablePaymentOptions(auth, dashData, allOptions = PaymentOptions) {
  const setting = auth?.checkout_settings;
  const enabled = setting
    ? allOptions.filter((option) => {
        if (option.name === "Card" && setting.card) return true;
        if (option.name === "Transfer" && setting.bank_transfer) return true;
        return false;
      })
    : allOptions;

  const { kobo, currency } = checkoutAmount(auth, dashData);
  const transferOffered = enabled.some((option) => option.name === "Transfer");
  // only drop card when transfer is there to pay with instead
  if (currency === "NGN" && kobo > CARD_MAX_NGN_KOBO && transferOffered) {
    return enabled.filter((option) => option.name !== "Card");
  }
  return enabled;
}
